<template>
  <div class="mains">
    <div class="campus">
      习题管理
      <span>></span>
      制作习题
      <span>></span>
      大题列表
      <span>></span>
      小题列表
      <span>></span>
      编辑判断题
    </div>
    <div class="student_test">
      <el-card>
        <div class="grid-content">
          <div class="rule">
            <div class="xiaoqu_1">制作习题</div>
            <div class="xiaoqu_2">
            </div>
          </div>
          <p class="tishi">
            <i>
              <img src="@/assets/img/education-manage/campus/shenzhong.png" alt />
            </i> 功能前方标注红色星号的属于必填内容，未标星号的是选填内容可进行自由填写，不同功能的备注事宜写在功能后方
          </p>
          <div class="form_1">
            <el-form ref="forms" :model="form" :rules="FormRules" label-width="5.20833vw">
              <el-form-item label="习题范例" prop="desc" v-show="show">
                <div class="xtfl1">
                  <h3>There are two apples in living room？</h3>
                  <div class="example_img">
                    <img src="../../../../assets/img/xitifanli.png" alt="">
                  </div>
                  <div class="example">
                    <span>1: YES</span>
                    <span>2: NO</span>
                  </div>
                  <el-button type="primary" @click="show=false" v-show="show">收起</el-button>
                </div>
              </el-form-item>
              <el-form-item label="小提题目" prop="title">
                <el-input type="textarea" v-model="form.title" class="xtfl" rows="5"></el-input>
                <div class="expansion">
                  <el-button type="primary" @click="show=true" v-show="!show">展开</el-button>
                </div>
              </el-form-item><el-form-item label="查看图片" prop="lookpicture">
                <div class="look_picture">
                  <img :src="imageUrl" class="avatar" />
                  <div class="replaceaudio">
                    <el-button v-if="imageUrl" @click="removeimage" type="primary" class="picture" round>删除图片</el-button>
                    <el-upload v-else action="#" :show-file-list="false" :http-request="handleAvatarSuccessImg" :before-upload="beforeAvatarUploadImg">
                      <div class="picture">
                        <el-button type="primary" round>
                          导入图片
                        </el-button>
                      </div>
                    </el-upload>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="小题选项" prop="chooseListAnswer">
                <el-radio-group v-model="form.chooseListAnswer" @change="selector()">
                  <div class="options">
                    <div class="options_left">
                      <p>1</p>
                      <el-radio :label="questionOptions[0]" class="options_left_radio">设为正确答案</el-radio>
                    </div>
                    <div class="options_right">
                      <el-input type="textarea" v-model="form.desc1" rows="9" cols="85"></el-input>
                    </div>
                  </div>
                  <div class="options">
                    <div class="options_left">
                      <p>2</p>
                      <el-radio :label="questionOptions[1]" class="options_left_radio">设为正确答案</el-radio>
                    </div>
                    <div class="options_right">
                      <el-input type="textarea" v-model="form.desc2" rows="9" cols="85"></el-input>
                    </div>
                  </div>

                </el-radio-group>
              </el-form-item>
              <el-form-item label="答案解析" prop="answerparse">
                <el-input type="textarea" v-model="form.answerparse" class="xtfl" rows="5" placeholder="您可自由输入该习题的答案解析"></el-input>
              </el-form-item>
              <el-form-item label="难易程度" prop="radios">
                <el-radio-group v-model="form.radios">
                  <el-radio :label="1">易</el-radio>
                  <el-radio :label="2">中</el-radio>
                  <el-radio :label="3">难</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="知识点" prop="knowledge">
                <el-input type="textarea" v-model="form.points" class="xtfl" rows="5" placeholder="您可自行输入该题目所涉及到的知识点，可自由选择是否输入"></el-input>
              </el-form-item>
              <el-form-item class="tijiao">
                <el-button type="primary" @click="uploadJudge()" v-if="edit" style="width:240px; height:46px; marginLeft:30px;">继续制题</el-button>
                <el-button type="primary" @click="editUpdate()" v-else style="width:240px; height:46px; marginLeft:30px;">保存编辑</el-button>
                <el-button style="width:240px; height:46px; marginLeft:30px;" v-show="edit" @click="comeBack=true">保存并返回</el-button>
                <div style="marginLeft:270px;" v-show="comeBack">
                  <el-button style="width:240px; height:46px; marginLeft:30px;" @click="comeBackBig(1)">返回大题列表</el-button>
                  <div>
                    <el-button style="width:240px; height:46px; marginLeft:30px;" @click="comeBacksmall(2)">返回小题列表</el-button>
                  </div>
                </div>
              </el-form-item>
            </el-form>
          </div>

        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
const axios = require('axios');
export default {
  data() {
    return {
      form: {
        title: '',
        desc1: '',
        desc2: '',
        answerparse: '',
        points: '',
        radios:'',
        chooseListAnswer: '',
      },
      FormRules: {
        title: [{ required: true, message: '请您填写必填信息', trigger: 'blur' }],
        chooseListAnswer: [{ required: true, message: '请您填写必填信息', trigger: 'blur' }],
        radios: [{ required: true, message: '请您填写必填信息', trigger: 'blur' }],
      },
      comeBack: false,
      questionOptions: [1, 2],
      chooseA: 0,
      chooseB: 0,
      radio1: '',
      audiosrc: '',
      show: true,
      src: '',
      id0: '',
      id1: '',
      edit: true,
      imageUrl: '',
      accountForm: {
        photo: {
          icon: require('@/assets/img/xitifanli.png'),
        },
      },
    };
  },
  created() {
    this.verdict();
  },

  methods: {
    verdict() {
      console.log(this.$route.query.questionId);
      if (this.$route.query.questionId === undefined) {
        console.log(111);
      } else {
        this.findquestion();
        this.edit = false;
      }
    },
    //删除图片
    removeimage(){
      this.imageUrl = '';
      this.$message.success('删除成功!');
    },
    //删除音频
    removeaudio(){
      this.audiosrc = '';
      this.$message.success('删除成功!');
    },
    //返回大题列表
    comeBackBig(big) {
      this.uploadJudge(big);
    },
    comeBacksmall(big) {
      this.uploadJudge(big);
    },
    // 上传音频
    handleAvatarSuccess(data) {
      let orgid = window.sessionStorage.getItem('orgid');
      let formData = new FormData();
      formData.append('audio', data.file);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/uploadOss/uploadAudio',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          console.log(result, 'awawa');
          this.audiosrc = result.data.data;
        })
        .catch((err) => {
          this.$message.error('上传音频错误：' + err);
        });
    },
    beforeAvatarUpload(file) {
      const flieArr = file.name.split('.');
      const isMP3 = flieArr[flieArr.length - 1] === 'mp3';
      const isLt2M = file.size / 1024 / 1024 < 100;

      if (!isMP3) {
        this.$message.error('上传音频只能是 MP3 格式!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传音频大小不能超过 100MB!');
        return false;
      }
      return isMP3 && isLt2M;
    },
    //查询题目
    findquestion() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/exercise/' + this.$route.query.questionId + '/t-f',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res);
        if (res.data.code === 0) {
          let data = res.data.data;
          this.form.title = data.text;
          this.imageUrl = data.img;
          this.form.radios = data.level;
          this.audiosrc = data.audio;
          this.form.answerparse = data.parse;
          this.form.points = data.points;
          this.form.desc1 = data.options[0].content;
          this.form.desc2 = data.options[1].content;
          this.id0 = data.options[0].id;
          this.id1 = data.options[1].id;
          for (let i = 0; i < data.options.length; i++) {
            if (data.options[i].right === 1) {
              this.form.chooseListAnswer = i + 1;
              console.log(this.form.chooseListAnswer);
            }
          }
        }
      });
    },
    //编辑提交
    editUpdate() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/exercise/' + this.$route.query.id + '/' + this.$route.query.questionId + '/t-f/upd',
        method: 'POST',
        data: {
          img: this.imageUrl,
          level: this.form.radios,
          parse: this.form.answerparse,
          points: this.form.points,
          score: 0,
          text: this.form.title,
          options: [
            {
              content: this.form.desc1,
              label: '1',
              id: this.id0,
              right: this.chooseA,
            },
            {
              content: this.form.desc2,
              label: '2',
              id: this.id1,
              right: this.chooseB,
            },
          ],
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        console.log(res);
        if (res.data.code === 0) {
          this.$message.success('编辑成功！');
          this.$router.go(-1);
        } else {
          this.$message.warning(res.data.message);
        }
      });
    },
    //提交判断题
    uploadJudge(big) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/exercise/make/t-f',
        method: 'POST',
        data: {
          attached: {
            bookId: Number(this.$route.query.bookid),
            section: this.$route.query.littleNode,
          },
          audio: this.audiosrc,
          img: this.imageUrl,
          level: this.form.radios,
          options: [
            {
              content: this.form.desc1,
              label: '1',
              right: this.chooseA,
            },
            {
              content: this.form.desc2,
              label: '2',
              right: this.chooseB,
            },
          ],
          pack: {
            number: this.$route.query.number,
            questionPackId: this.$route.query.id,
            score: 0,
          },
          parse: this.form.answerparse,
          points: this.form.points,
          score: 0,
          text: this.form.title,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro.then((res) => {
        if (res.data.code === 0) {
          this.$message.success('上传成功!');
          if(big === 1) {
            this.$router.go(-2);
          } else if (big===2) {
            this.$router.go(-1);
          }
          this.audiosrc = '';
          this.imageUrl = '';
          this.form.radios = '';
          this.form.desc1 = '';
          this.form.desc2 = '';
          this.chooseA = '';
          this.chooseB = '';
          this.form.chooseListAnswer = '';
          this.form.answerparse = '';
          this.form.points = '';
          this.form.title = '';
        } else {
          this.$message.error(res.data.message);
        }
      }).catch((err) => {
         if(big ==1||big==2){
             this.$confirm('必填信息出错，退出信息将被清空，确定退出?', '退出', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            console.log(111);
            if (big === 1) {
              this.$router.go(-2);
            } else if (big === 2) {
              this.$router.go(-1);
            }
          });
          }else {
            this.$message.error('制题失败:'+err)
          }
        });
    },
    selector() {
      console.log(this.form.chooseListAnswer);
      if (this.form.chooseListAnswer == 1) {
        this.chooseA = 1;
        this.chooseB = 0;
      } else if (this.form.chooseListAnswer == 2) {
        this.chooseA = 0;
        this.chooseB = 1;
      }
      console.log(this.chooseA, this.chooseB, 'aaaa');
    },
    //上传图片
    handleAvatarSuccessImg(data) {
      console.log(data.file);
      let orgid = window.sessionStorage.getItem('orgid');
      let formData = new FormData();
      formData.append('file', data.file);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/uploadOss/uploadImage',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code === 0) {
            this.imageUrl = result.data.data;
            console.log(this.imageUrl);
          }
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('上传图片错误：' + err);
        });
    },
    beforeAvatarUploadImg(file) {
    //   const isJPG = file.type === 'image/jpeg';
    //   const isPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      // if (!isPNG) {
      //   this.$message.error('上传图片只能是 JPG或者PNG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
  },
};
</script>
<style lang="less">
.mains {
  box-sizing: border-box;
}
.el-card_body {
  position: relative;
}
.tishi {
  position: absolute;
  width: 100%;
  top: 60px;
  left: 0;
  color: #f87e2e;
  background-color: #feefe5;
}
.tishi i {
  margin-left: 55px /* 55/16 */;
}
.form_1 {
  margin-top: 70px;
  margin-left: 273px;
}
.xiaoqu_1 {
  font-weight: 700;
}
.xtfl {
  width: 750px /* 750/16 */;
}
.expansion {
  position: absolute;
  top: 0;
  right: 360px;
}
.xtfl1 {
  position: relative;
  width: 750px /* 750/16 */;
  height: 200px /* 200/16 */;
  border: 1px solid #cccccc;
}
.xtfl1 button {
  position: absolute;
  top: 0;
  right: -100px;
}
.xtfl1 h3 {
  margin-left: 30px /* 30/16 */;
  margin-top: 10px;
}
.example {
  margin-left: 30px /* 30/16 */;
  margin-top: -20px;
}
.example span {
  display: inline-block;
  margin-right: 10px;
}
.example_img {
  margin-left: 30px /* 30/16 */;
  width: 100px /* 100/16 */;
  height: 100px /* 100/16 */;
}
.options {
  display: flex;
  width: 750px /* 750/16 */;
  height: 200px /* 200/16 */;
  border: 1px solid #cccccc;
  margin-bottom: 20px;
}
.options_left {
  width: 130px;
  height: 100%;
  background-color: #cccccc;
  color: white;
  text-align: center;
}
.options_left p {
  font-size: 16px;
  margin-top: 70px;
}
.options_left_radio {
  color: #fff;
}
.addLable {
  width: 200px /* 200/16 */;
  height: 36px /* 36/16 */;
}
.btn_addlable {
  width: 96px /* 96/16 */;
  height: 34px /* 34/16 */;
  margin-left: 25px /* 25/16 */;
}
.el-textarea__inner {
  resize: none;
}
.score {
  display: flex;
}
.score > :nth-child(2) {
  margin: 0 110px 0 140px;
}
.grade {
  width: 100px /* 100/16 */;
}
.tishi {
  width: 100%;
  top: 60px;
  left: 0;
  color: #f87e2e;
  background-color: #feefe5;
}
.tishi i {
  margin-left: 55px /* 55/16 */;
}
.lookPicture {
  width: 750px;
  height: 110px;
  border: 1px solid rgba(204, 204, 204, 1);
  padding-top: 10px;
}
.addaudio {
  display: flex;
  width: 730px;
  height: 55px;
  border: 1px solid rgba(204, 204, 204, 1);
  padding: 10px;
}
.replaceaudio {
  width: 100px /* 65/16 */;
  height: 42px;
  button {
    width: 100%;
    height: 100%;
    text-align: center;
  }
}
.replaceaudio {
  position: relative;
  width: 100px /* 65/16 */;
  height: 42px;
  button {
    width: 100%;
    height: 100%;
    text-align: center;
  }
  .picture {
    position: absolute;
    width: 100px;
    height: 42px;
    margin-left: 200px;
    bottom: 40px;
  }
}
.look_picture {
  width: 750px;
  height: 200px;
  border: 1px solid #cccccc;
}
.avatar {
  width: 178px;
  height: 178px;
}
</style>
